var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"copyright_img"},[_c('p',[_vm._v("監察院客服服務專線：客服專線：(02)2341-3183 分機:495    傳真:(02)2341-2650")]),_c('p',[_vm._v("建議使用IE 11以上版本 最佳觀看解析度1366x768")])])])
}]

export { render, staticRenderFns }